module.exports = __webpack_public_path__ + "static/media/fishing.e21dc6ea.png";